import React, { Component } from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CheckList from '../../taskCheckList/ChekList'

class FormCreateCkeckList extends Component {
    constructor(props){
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: this.props.label.check_lists,

            formCreateChecklist: {
                name: "Checklist",
                task_label_id: this.props.label.id,
            },
        }
    }

    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //añadir nuevo item en el checklists
    updateDataItems = (register) => {
        this.setState({
            data: this.state.data.map(item => {
                if (register.check_list_id === item.id) {
                    return {
                        ...item,
                        check_list_items: [...item.check_list_items, register]
                    }
                }
                return item;
            })
        });
    }

    //actualiza el item del checklist 
    updateCheckListItem = (register) => {
        this.setState({
            data: this.state.data.map(item => {
                if (register.check_list_id === item.id) {
                    return {
                        ...item,
                        check_list_items: item.check_list_items.map(check_list_item => {
                            if (register.id === check_list_item.id) {
                                return {
                                    ...check_list_item,
                                    date: register.data, 
                                    state: register.state,  
                                    description: register.description,  
                                    position: register.position, 
                                }
                            }
                            return check_list_item;
                        })
                    }
                }
                return item;
            })
        });
    }

    //elimina un item del checklist
    deleteCheckListItem = (check_list_id, check_list_item_id) => {
        this.setState({
            data: this.state.data.map(item => {
                if (check_list_id === item.id) {
                    return {
                        ...item,
                        check_list_items: item.check_list_items.filter(check_list_item => check_list_item.id != check_list_item_id),
                    }
                }
                return item;
            })
        });
    }

    //elimina un checklist
    deleteDataCheckList = (check_list_id) => {
        this.setState({
            data: this.state.data.filter(check_list => check_list.id != check_list_id),
        });
    }

    HandleClickCheckList = () => {
        fetch(`/task/check_lists`, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(this.state.formCreateChecklist), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.updateData(data.register);
            this.props.updateDataCheckLists(data.register)
        });
    }

    HandleChangeChecklist = (e) => {
        this.setState({
            formCreateChecklist: {
                ...this.state.formCreateChecklist,
                [e.target.name]: e.target.value,
            }
        });
    }

    updateItemChecklist = (ckeck) => {
        this.setState({
            data: this.state.data.map(item => {
            if (ckeck.id === item.id) {
              return { ...item, 
                name: ckeck.name, 
              }
            }
            return item;
          })
        });
    }

    loadCheckList = () => {
        fetch(`/task/get_check_list_labels/${this.props.label.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
            });
        });
    }

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {this.props.title}</ModalHeader>
                        <ModalBody>
                            <div className="row">

                                <div className="col-md-12">
                                    <div className="card">
                                        <form onSubmit={this.handleSubmit}>
                                            <div className="card-body">
                                                <label>Nombre </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    value={this.state.formCreateChecklist.name}
                                                    onChange={this.HandleChangeChecklist}
                                                    className={`form form-control`}
                                                    placeholder="Nombre"
                                                />
                                            </div>

                                            <div className="card-footer">
                                                <button 
                                                    className="btn-shadow btn btn-info" 
                                                    onClick={() => this.HandleClickCheckList()}
                                                >
                                                    Añadir
                                                </button>
                                            </div>

                                        </form>
                                        
                                    </div>
                                </div>

                                {this.state.data.length >= 1 && (
                                    <CheckList
                                        dataChecklist={this.state.data}
                                        loadCheckList={this.loadCheckList}
                                        messageSuccess={this.messageSuccess}
                                        updateData={this.props.updateData}
                                        users={this.props.users}
                                        user={this.props.user}
                                        task={this.props.task}
                                        updateItemChecklist={this.updateItemChecklist}
                                        updateItem={this.props.updateItem}
                                        showFields={true}

                                        //update data 
                                        updateDataItems={this.updateDataItems}
                                        updateCheckListItem={this.updateCheckListItem}
                                        deleteCheckListItem={this.deleteCheckListItem}


                                        deleteCheckLists={this.props.deleteCheckLists}
                                        deleteDataCheckList={this.deleteDataCheckList}
                                    />
                                )}

                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <label className="btn btn-light mt-2" onClick={() => this.props.toggle()}>Cerrar</label>
                        </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FormCreateCkeckList;